<template>
  <div class="relative mt-4">
    <new-table-lite
      class="admin-table summary Totals"
      :is-loading="table.isLoading"
      :is-static-mode="true"
      :is-slot-mode="true"
      :columns="columnsProduct"
      :rows="table.rows"
      :total="table.totalRecordCount"
      :sortable="table.sortable"
      @is-finished="table.isLoading = false"
      :page-size="table.pagesize"
      :pageOptions="table.pageOptions"
      :has-checkbox="false"
      :is-hide-paging="false"
      :pageSizeChangeLabel="'pageSizeChangeLabel'"
      :messages="tableMessages"
    >
      <template v-slot:filter>
        <tr class="vtl-thead-tr z-20">
          <td class="vtl-tbody-td">
            <span>Totals</span>
          </td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td">{{ sumPayload.itemsSold }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.itemsRefunded }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.netQty }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossSale) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.subTotal) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalDiscount) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalOtherDiscount) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalPromotionDiscount) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalPromoCodeDiscount) }}</td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td">{{ sumPayload.rewardRedemption }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalTax) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalCost) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossProfit) }}</td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossProfit/sumPayload.subTotal*100) }}</td>
        </tr>
      </template>

      <template v-slot:subTotal="data">
        <span>{{ displayPriceFormat(data.value.subTotal) }}</span>
      </template>
      <template v-slot:totalDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalDiscount) }}</span>
      </template>
      <template v-slot:totalOtherDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalOtherDiscount) }}</span>
      </template>
      <template v-slot:totalPromotionDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalPromotionDiscount) }}</span>
      </template>
      <template v-slot:totalPromoCodeDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalPromoCodeDiscount) }}</span>
      </template>
      <template v-slot:totalTax="data">
        <span>{{ displayPriceFormat(data.value.totalTax) }}</span>
      </template>
      <template v-slot:totalCost="data">
        <span>{{ displayPriceFormat(data.value.totalCost) }}</span>
      </template>
      <template v-slot:grossProfit="data">
        <span>{{ displayPriceFormat(data.value.grossProfit) }}</span>
      </template>
      <template v-slot:grossMargin="data">
        <span>{{ displayPriceFormat(data.value.grossMargin) }}</span>
      </template>
    </new-table-lite>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import Env from '@/env'
import StringHelpers from '@/helpers/string'
import NewTableLite from '@/components/table/tableLite.vue'

const tableMessages = {
  pagingInfo: 'Total: {2}',
  pageSizeChangeLabel: 'Items per Page',
  gotoPageLabel: '',
  noDataAvailable: 'No records found!',
}

export default defineComponent({
  components: {
    NewTableLite,
  },
  props: {
    payload: {
      type: Array,
      required: false,
      default: () => [],
    },
    sumPayload: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup() {
    const columnsProduct = ref([
      {
        label: 'Location',
        field: 'location',
        sortable: false,
      },
      {
        label: 'Category',
        field: 'category',
        sortable: false,
      },
      {
        label: 'Compliance Type',
        field: 'complianceType',
        sortable: false,
      },
      {
        label: 'Brand',
        field: 'brand',
        sortable: false,
      },
      {
        label: 'Licensed Producer',
        field: 'licensedProducer',
        sortable: false,
      },
      {
        isKey: true,
        label: 'Product',
        field: 'product',
        sortable: false,
        headerClasses: 'width',
      },
      {
        label: 'Variant',
        field: 'productVariationName',
        sortable: false,
        headerClasses: 'width',
      },
      {
        label: 'SKU',
        field: 'sku',
        sortable: false,
      },
      {
        label: 'Items Sold',
        field: 'itemsSold',
        sortable: false,
      },
      {
        label: 'Items Refunded',
        field: 'itemsRefunded',
        sortable: false,
      },
      {
        label: 'Net Qty Sold',
        field: 'netQty',
        sortable: false,
      },
      {
        label: 'Gross Sales',
        field: 'grossSale',
        sortable: false,
      },
      {
        label: 'Net Sales',
        field: 'subTotal',
        sortable: false,
      },
      {
        label: 'Total Discounts',
        field: 'totalDiscount',
        sortable: false,
      },
      {
        label: 'Total Other Discounts',
        field: 'totalOtherDiscount',
        sortable: false,
      },
      {
        label: 'Total Promotion Discounts',
        field: 'totalPromotionDiscount',
        sortable: false,
      },
      {
        label: 'Total Promo Code Discounts',
        field: 'totalPromoCodeDiscount',
        sortable: false,
      },
      {
        label: 'Markdown %',
        field: 'markdownPercent',
        sortable: false,
      },
      {
        label: 'Reward Tiers',
        field: 'rewardRedemption',
        sortable: false,
      },
      {
        label: 'Total Tax',
        field: 'totalTax',
        sortable: false,
      },
      {
        label: 'Cost of Goods Sold',
        field: 'totalCost',
        sortable: false,
      },
      {
        label: 'Gross Profit',
        field: 'grossProfit',
        sortable: false,
      },
      {
        label: 'Avg Retail Price',
        field: 'averageRetailPrice',
        sortable: false,
      },
      {
        label: 'Gross Margin',
        field: 'grossMargin',
        sortable: false,
      },
    ])
    const table = ref({
      isLoading: false,
      rows: [],
      totalRecordCount: 0,
      sortable: {
        order: 'name',
        sort: 'asc',
      },
      pagesize: Env.defaultPageSize,
      pageOptions: Env.pageList,
      count: 0,
      page: 1,
    })

    return {
      table,
      columnsProduct,
      tableMessages,
    }
  },
  mounted() {
    this.load()
    this.emitter.on('reloadSalesList', this.reload)
  },
  beforeDestroy() {
    this.emitter.off('reloadSalesList', this.reload)
  },
  methods: {
    displayPriceFormat(price) {
      return StringHelpers.roundOff(price, 2)
    },
    reload() {
      this.$nextTick(() => {
        this.load()
      })
    },
    load() {
      this.table.rows = this.payload
      this.table.totalRecordCount = this.payload.length
      this.table.isLoading = false
    },
  },
})
</script>
